export default __webpack_public_path__ + "static/media/checkmark.02bec59c.svg";